import * as yup from 'yup';
import { NO_WHITESPACE_STRING_REGEX } from '../constants/regex';

// Credit: https://github.com/jquense/yup/issues/507
export const STRICT_EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape

const emailValidator = yup
  .string()
  .trim()
  .matches(NO_WHITESPACE_STRING_REGEX, 'Email cannot have spaces')
  .lowercase()
  .email('Email must be a valid email')
  // Yup's built-in email validation doesn't reject emails with only one character after the dot (but FUB does), so we need a stricter regex
  .matches(STRICT_EMAIL_REGEX, 'Email must be a valid email');

export default emailValidator;

const emailRequiredValidator = emailValidator.required('Email is required');
export { emailRequiredValidator };
